import { User as UserAuth } from '@/app/_constant/authType';

export const createUserObject = (authProfile?: UserAuth): User => {
    if (authProfile == undefined) {
        return {
            client: { id: '0', language: 'id-ID' },
            detail: { email: '', name: '', phoneNumber: '' },
            login: { id: '', status: 'logged-out', type: 'Email' },
        };
    }
    const user: User = {
        detail: {
            email: authProfile?.email ?? '',
            name: authProfile?.name ?? '',
            phoneNumber: authProfile?.phone_number ?? '',
            isLogin: authProfile != undefined,
            isVerified: authProfile != undefined,
            role: authProfile.user_type == 1 ? 'AGENT' : 'CONSUMER',
        },
        client: {
            id: '0',
            language: 'id-ID',
        },
        login: {
            id: authProfile?.uuid ?? '',
            status: authProfile != undefined ? 'logged-in' : 'logged-out',
            type: 'EMAIL',
        },
    };

    return user;
};
